import { useState } from "react";
import toast from "react-hot-toast";
import { RiCloseLargeFill } from "react-icons/ri";
import "../Styles/updateProfile.css";
import { useAuth } from "../../context/Auth";
const UpdateProfile = ({ onClose }) => {
  const [auth, setAuth] = useAuth();
  const userid = auth.user.id;
  console.log(auth);
  const [formData, setFormData] = useState({
    name: "",
    photo: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, photo: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append("userId", userid);
    form.append("name", formData.name);
    if (formData.photo) form.append("image", formData.photo);

    try {
      const response = await fetch(
        "https://portfoliomern-mxue.onrender.com/api/v1/auth/user-update",
        {
          method: "POST",
          body: form,
        }
      );
      const data = await response.json();
      if (data.success) {
        toast.success("Profile updated successfully");
        onClose(); // form submit hone ke baad popup close
      } else {
        toast.error(data.message || "Profile update failed");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="popup-header">
          <h2>Update Profile</h2>
          <RiCloseLargeFill className="close-icon" onClick={onClose} />
        </div>

        <form onSubmit={handleSubmit}>
          <input type="file" name="image" onChange={handleFileChange} />

          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Enter username"
          />
          <button type="submit">Save</button>
        </form>
      </div>
    </div>
  );
};

export default UpdateProfile;
